import { useNavigate } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { NewBudgetWizard } from 'modules/finance/components/NewBudgetWizard'
import { useBudgetsPage } from 'modules/finance/hooks/useBudgets'

const NewBudgetPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { legalEntities, features } = useBudgetsPage(companyId)

  const handleSuccess = (budgetId: number) => {
    app.setFlash({ type: 'correct', message: i18n.t('common.saved_successfully') })

    navigate(navigation.expenses.budgets.detail.fullPath({ budgetId }))
  }
  const handleError = () => {
    app.setFlash({ type: 'wrong', message: i18n.t('errors.generic_error') })
  }
  return (
    <AuthorizeUser authorizeFn={() => true}>
      <NewBudgetWizard
        legalEntities={legalEntities}
        features={features}
        onSuccess={handleSuccess}
        onError={handleError}
      />
    </AuthorizeUser>
  )
}

export default NewBudgetPage
